import Immutable from 'immutable';
import {
  FLAG_GETTING_ITINERARY_SCHEDULES,
  GET_ITINERARY_SCHEDULES,
  CLEAR_ITINERARY_SCHEDULES,
  FLAG_ITINERARY_SCHEDULE_ACTIVITY,
  GET_ITINERARY_SCHEDULE,
  CLEAR_ITINERARY_SCHEDULE,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_ITINERARY_SCHEDULES:
      return state.setIn(['all', 'loading'], payload);
    case GET_ITINERARY_SCHEDULES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_ITINERARY_SCHEDULES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_ITINERARY_SCHEDULE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_ITINERARY_SCHEDULE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_ITINERARY_SCHEDULE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
